'use client'

interface LoadingScreenProps {
  label?: string
}

/**
 * Full-viewport loading state — plain HTML + CSS only (no Chakra/Emotion).
 * Avoids hydration mismatches when rendered during SSR or before Emotion flushes styles.
 * Uses Chakra CSS variables when available, with globals.css fallbacks.
 */
export default function LoadingScreen({ label = 'Loading…' }: LoadingScreenProps) {
  return (
    <div
      className="loading-screen"
      role="status"
      aria-label={label}
      style={{ background: 'var(--chakra-colors-app-bg, var(--loading-bg))' }}
    >
      <div
        className="loading-spinner"
        aria-hidden="true"
        style={{
          borderColor: 'var(--chakra-colors-spinner-track, var(--loading-track))',
          borderTopColor: 'var(--chakra-colors-accent, var(--loading-accent))',
        }}
      />
      <span className="sr-only">{label}</span>
    </div>
  )
}
